import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FilterProductService } from "../../services/MainScreen";
import {
  BASE_URL,
  GOTOPRODUCTDETAILS_URL_LOCAL,
  SEARCH_PRODUCT_URL_LOCAL,
} from "../../utility/BaseUrl";

const SearchProduct = ({ data }) => {
  const { categories } = data;

  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filters, setFilters] = useState({
    color: "",
    category: "",
    minPrice: "",
    maxPrice: "",
    search: "",
  });

  const navigate = useNavigate();
  const location = useLocation();

  const formatNumber = (value) => {
    if (!value) return "";
    return value
      .toString()
      .replace(/\D/g, "")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    const searchValue = formData.get("search") || "";
    const categoryValue = formData.get("category") || "";
    const minPrice = formData.get("minPrice").replace(/,/g, "") || 0; // حذف کاما
    const maxPrice = formData.get("maxPrice").replace(/,/g, "") || 0; // حذف کاما

    const queryParams = new URLSearchParams();
    if (searchValue) queryParams.set("search", searchValue);
    if (categoryValue) queryParams.set("category", categoryValue);
    if (minPrice > 0) queryParams.set("minPrice", minPrice);
    if (maxPrice > 0) queryParams.set("maxPrice", maxPrice);

    navigate(`?${queryParams.toString()}`);
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    const queryParams = new URLSearchParams(location.search);
    const newFilters = {
      color: queryParams.get("color") || "",
      category: queryParams.get("category") || "",
      minPrice: queryParams.get("minPrice") || "",
      maxPrice: queryParams.get("maxPrice") || "",
      search: queryParams.get("search") || "",
    };
    setFilters(newFilters);

    const fetchFilteredProducts = async () => {
      const { maxPrice, minPrice, search, color, category } = newFilters;
      const response = await FilterProductService(
        category,
        encodeURIComponent(color),
        search,
        maxPrice || "",
        minPrice || ""
      );
      setFilteredProducts(response.results.result);
    };

    fetchFilteredProducts();
  }, [location.search]);

  return (
    <>
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10 col-xl-9">
            <div className="page-context search-context">
              <h1 className="page-title search-title mb-0">جستجو در وب‌سایت</h1>

              <form
                onSubmit={handleSearchSubmit}
                className="search-form mt-25 container"
              >
                <div className="row col-12 col-sm-6 form-group signin-username">
                  <label class="col-form-label col-md-3 text-md-left signin-username-label">
                    جستجو
                  </label>
                  <div className="col-12">
                    <input
                      type="text"
                      name="search"
                      className="form-control search-query-input"
                      placeholder="این‌جا بنویسید..."
                      defaultValue={filters.search}
                    />
                  </div>
                </div>

                <div className="row col-12 col-sm-6 form-group signin-username">
                  <label class="col-form-label col-md-3 text-md-left signin-username-label">
                    دسته بندی
                  </label>
                  <div className="col-12">
                    {categories ? (
                      <select
                        className="form-control form-select"
                        name="category"
                      >
                        <option value="">دسته‌بندی‌ها</option>
                        {categories.map((item) =>
                          item.title === filters.category ? (
                            <option key={item.slug} value={item.title} selected>
                              {item.title}
                            </option>
                          ) : (
                            <option key={item.slug} value={item.title}>
                              {item.title}
                            </option>
                          )
                        )}
                      </select>
                    ) : null}
                  </div>
                </div>
                <div className="row col-12 col-sm-6 form-group signin-username">
                  <label class="col-form-label col-md-3 text-md-left signin-username-label">
                    قیمت از
                  </label>
                  <div className="col-12">
                    <input
                      type="text"
                      name="minPrice"
                      value={filters.minPrice}
                      className="form-control"
                      placeholder="کمترین قیمت"
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          minPrice: formatNumber(e.target.value),
                        })
                      }
                    />
                  </div>
                </div>
                <div className="row col-12 col-sm-6 form-group signin-username">
                  <label class="col-form-label col-md-3 text-md-left signin-username-label">
                    قیمت تا
                  </label>
                  <div className="col-12">
                    <input
                      type="text"
                      name="maxPrice"
                      className="form-control"
                      value={filters.maxPrice}
                      placeholder="بیشترین قیمت"
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          maxPrice: formatNumber(e.target.value),
                        })
                      }
                    />
                  </div>
                </div>

                <div className="row col-12 justify-content-center">
                  <button className="btn btn-warning mx-2 btn-lg" type="submit">
                    جستجو
                  </button>
                  <button
                    className="btn btn-danger mx-2 btn-lg"
                    type="button"
                    onClick={() => {
                      setFilters({
                        color: "",
                        category: "",
                        minPrice: "",
                        maxPrice: "",
                        search: "",
                      });
                      navigate(SEARCH_PRODUCT_URL_LOCAL);
                    }}
                  >
                    پاک کردن فیلتر
                  </button>
                </div>
              </form>

              <div className="search-result mt-20">
                <div className="store-products store-compact-products">
                  <div className="row mx-n10 mx-sm-n15 pt-30">
                    {filteredProducts ? (
                      filteredProducts.map((item, index) => {
                        const {
                          product_cover,
                          product_cover_title,
                          product_cover_alt,
                          product_name,
                          inventory_of_product,
                          slug,
                        } = item;
                        return (
                          <div className="col-12 col-sm-6 col-lg-4 col-xxl-3">
                            <article className="product-carousel-item store-compact-product store-compact-product-outofstock">
                              <div className="card text-center product-carousel-item-card">
                                <Link
                                  to={GOTOPRODUCTDETAILS_URL_LOCAL(slug)}
                                  title={product_name}
                                >
                                  <img
                                    src={BASE_URL + product_cover}
                                    className="card-img-top cart-text-btn-img"
                                    alt={product_cover_alt}
                                    title={product_cover_title}
                                  />
                                </Link>
                                <div className="card-body cart-text-btn-body">
                                  <Link
                                    to={GOTOPRODUCTDETAILS_URL_LOCAL(slug)}
                                    title={product_name}
                                  >
                                    <h3 className="card-title cart-text-btn-title">
                                      {product_name}
                                    </h3>
                                  </Link>
                                  <div className="card-price text-brown cart-text-btn-price">
                                    {formatNumber(
                                      inventory_of_product.final_price
                                    )}
                                    تومان
                                  </div>
                                  {/* <span className="store-compact-product-outofstock-message">
                                    ناموجود
                                  </span> */}
                                </div>
                              </div>
                            </article>
                          </div>
                        );
                      })
                    ) : (
                      <div class="page-empty search-empty alert alert-warning mt-20 mb-0 text-xs">
                        جستجو نتیجه ای نداشت!
                      </div>
                    )}
                  </div>
                </div>
                {/* <nav role="navigation">
                  <ul className="pagination mb-0">
                    <li className="page-item active">
                      <a
                        href="/site/search?q=%d8%a8%d9%84%d9%86%d8%af%da%af%d9%88&page=1"
                        className="page-link rounded shadow-sm"
                      >
                        1
                      </a>
                    </li>
                    <li className="page-item ">
                      <a
                        href="/site/search?q=%d8%a8%d9%84%d9%86%d8%af%da%af%d9%88&page=2"
                        className="page-link rounded shadow-sm"
                      >
                        2
                      </a>
                    </li>
                    <li className="page-item ">
                      <a
                        href="/site/search?q=%d8%a8%d9%84%d9%86%d8%af%da%af%d9%88&page=3"
                        className="page-link rounded shadow-sm"
                      >
                        3
                      </a>
                    </li>
                    <li className="page-item ">
                      <a
                        href="/site/search?q=%d8%a8%d9%84%d9%86%d8%af%da%af%d9%88&page=4"
                        className="page-link rounded shadow-sm"
                      >
                        4
                      </a>
                    </li>
                    <li className="page-item ">
                      <a
                        href="/site/search?q=%d8%a8%d9%84%d9%86%d8%af%da%af%d9%88&page=5"
                        className="page-link rounded shadow-sm"
                      >
                        5
                      </a>
                    </li>
                    <li className="page-item ">
                      <a
                        href="/site/search?q=%d8%a8%d9%84%d9%86%d8%af%da%af%d9%88&page=6"
                        className="page-link rounded shadow-sm"
                      >
                        6
                      </a>
                    </li>
                    <li className="page-item ">
                      <a
                        href="/site/search?q=%d8%a8%d9%84%d9%86%d8%af%da%af%d9%88&page=7"
                        className="page-link rounded shadow-sm"
                      >
                        7
                      </a>
                    </li>
                    <li className="page-item ">
                      <a
                        href="/site/search?q=%d8%a8%d9%84%d9%86%d8%af%da%af%d9%88&page=8"
                        className="page-link rounded shadow-sm"
                      >
                        8
                      </a>
                    </li>
                    <li className="page-item">
                      <a
                        href="/site/search?q=%d8%a8%d9%84%d9%86%d8%af%da%af%d9%88&page=2"
                        className="page-link rounded shadow-sm"
                      >
                        <i className="fa fa-angle-left" />
                      </a>
                    </li>
                  </ul>
                </nav> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchProduct;
